define.alias("shared/components/shared/pre-boarding/context-modal/side-plan-card", "media/components/shared/pre-boarding/context-modal/side-plan-card");